/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllEventLookups = require('../../common/services/GetAllEventLookups');
var GetEvent = require('../services/GetEvent');

var COCEditEventDetailsView = require('../views/COCEditEventDetailsView');

module.exports = function(eventId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetAllEventLookups(), GetEvent(eventId))
    .done(function(lookups, event) {
      NavUtils.navigate('coc/event/' + eventId + '/edit');

      Scaffold.content.show(
        new COCEditEventDetailsView({
          model: new Backbone.Model({
            eventTypes: lookups.eventTypes,
            targetAudiences: lookups.targetAudiences,
            eventFormats: lookups.eventFormats,
            programs: lookups.programs,
            event: event,
            eventId: eventId,
            view: 'edit'
          })
        })
      );

      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
